import * as React from "react"

type ContainerProps = {
  children: any
  className?: string
  extraProps?: any
}

export const Container = (p: ContainerProps) => {
  return <div className={`container-fluid ${p.className ? p.className : ''}`} {...p.extraProps}>{p.children}</div>
}

export const Row: React.StatelessComponent = ({ children }) => <div className="row">{children}</div>

export const Block: React.StatelessComponent = ({ children }) => <div className="page-block">{children}</div>
